import { Asset, Bay, Inspection, IssueCfg, LocalizedRiskLevel, System, Warehouse } from '@damofire/data-watson';
import { Bounds, CanvasDisplayPrecision, CanvasZoomState } from '@damofire/uix-commons';

export enum LayoutDisplayMode {
  ISSUES = 'ISSUES',
  CAPACITY = 'CAPACITY',
  REPAIRS = 'REPAIRS',
}

export type DisplayModes = 'issues' | 'repairs' | 'elevation' | 'notes';

export class WarehouseLayoutModel {
  warehouse: Warehouse;
  zoomState: CanvasZoomState = { canReset: false, canZoomIn: true, canZoomOut: false };
  warehouseBounds: Bounds = {
    minX: Number.MAX_VALUE,
    minY: Number.MAX_VALUE,
    maxX: -Number.MAX_VALUE,
    maxY: -Number.MAX_VALUE,
    width: 0,
    height: 0,
  };
  canvasBounds: Bounds = { width: 0, height: 0 };

  private _selectedIssueAssetId: number;
  private _selectedRepairAssetId: number;
  private _selectedBay: Bay;
  selectedBayData: unknown;

  assets: Asset[] = [];
  systems: { [key: number]: System };

  priorityFilter: number[] = [];
  componentFilter: number[] = [];
  inspection: Inspection;
  withNotes: boolean;
  section: string;

  displayMode = LayoutDisplayMode.ISSUES;
  displayPrecision = CanvasDisplayPrecision.FULL;
  previewDisplayMode: DisplayModes = 'issues';

  currentLang: string;
  issueCfg: IssueCfg;
  priorities: LocalizedRiskLevel[];
  labels: Record<string, string> = {};

  updateSelectedIssueId(assetId: number): void {
    this._selectedIssueAssetId = assetId;
    this._selectedRepairAssetId = null;
    this._selectedBay = null;
    this.previewDisplayMode = 'issues';
  }

  updateSelectedRepairId(assetId: number): void {
    this._selectedIssueAssetId = null;
    this._selectedRepairAssetId = assetId;
    this._selectedBay = null;
    this.previewDisplayMode = 'repairs';
  }

  updateSelectedBay(bay: Bay): void {
    this._selectedIssueAssetId = null;
    this._selectedRepairAssetId = null;
    this._selectedBay = bay;

    if (!this.inspection) {
      this.previewDisplayMode = 'elevation';
    } else {
      this.previewDisplayMode = 'issues';
    }
  }

  get selectedRepairAssetId(): number {
    return this._selectedRepairAssetId;
  }

  get selectedIssueAssetId(): number {
    return this._selectedIssueAssetId;
  }

  get selectedBay(): Bay {
    return this._selectedBay;
  }

  getSelectedAsset(): string {
    if (this._selectedIssueAssetId) {
      return `${this._selectedIssueAssetId}`;
    }
    if (this._selectedRepairAssetId) {
      return `${this._selectedRepairAssetId}`;
    }
    return this.selectedBay?.leftAssetId;
  }
}
